<template>
  <div>
    <div class="flex gap-2 text-primary mb-6">
      <v-icon
        color="primary"
        :size="20">
        mdi-console
      </v-icon>
      <span class="text-xl font-medium">{{ $t('salepage.header') }}</span>
    </div>
    <sale-page-basic />
  </div>
</template>

<script>
import SalePageBasic from './components/SalePageBasic.vue'

export default {
  components: {
    SalePageBasic
  }
}
</script>

<style scoped>

</style>
